import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7dfefe3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "information bg-white border-bottom border-outline-color p-3" }
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_5 = { class: "flex-grow-1" }
const _hoisted_6 = { class: "text-size-14 text-weight-500" }
const _hoisted_7 = { class: "notification flex-shrink-0 d-flex flex-column justify-content-between align-items-end" }
const _hoisted_8 = { class: "text-mild text-size-12 mb-1" }
const _hoisted_9 = { class: "arrow flex-shrink-0" }
const _hoisted_10 = {
  key: 1,
  class: "p-3 m-3 bg-white text-size-14 text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessagesNav = _resolveComponent("MessagesNav")!
  const _component_AppBadge = _resolveComponent("AppBadge")!
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_PullToRefresh = _resolveComponent("PullToRefresh")!
  const _component_AppFooter = _resolveComponent("AppFooter")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_MessagesNav, {
      unreadMessageCount: _ctx.unreadMessageCount,
      unreadInformationCount: _ctx.unreadInformationCount
    }, null, 8, ["unreadMessageCount", "unreadInformationCount"]),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PullToRefresh, {
        onPull: _ctx.pullToFetchInformationTargets,
        isShowingPullToRefreshLoading: _ctx.isShowingPullToRefreshLoading
      }, {
        default: _withCtx(() => [
          (_ctx.informationTargets.length > 0)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.informationTargets, (target) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: target.id
                  }, [
                    _createVNode(_component_RouterLink, {
                      to: {
                name: 'InformationDetail',
                params: { informationId: target.information.id }
              }
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                              _createElementVNode("p", _hoisted_6, _toDisplayString(target.information.title), 1)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.toDisplayTime(target.information.updatedAt)), 1),
                              _createTextVNode(),
                              (target.isRead === false)
                                ? (_openBlock(), _createBlock(_component_AppBadge, {
                                    key: 0,
                                    variant: "red"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("未読\n                    ")
                                    ], undefined, true),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_9, [
                              _createVNode(_component_FeatherIcon, {
                                icon: "chevron-right",
                                size: "1x",
                                class: "text-gray-05 ml-2"
                              })
                            ])
                          ])
                        ])
                      ], undefined, true),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_10, "\n          まだお知らせはありません\n        "))
        ], undefined, true),
        _: 1
      }, 8, ["onPull", "isShowingPullToRefreshLoading"])
    ]),
    _createTextVNode(),
    _createVNode(_component_AppFooter)
  ]))
}